import { Option } from '~/core/shared/types';

export enum PersonalLiability {
  HomeLoan = 'home_loan',
  InvestmentProperty = 'investment_property',
  AutoOrPersonalLoan = 'auto_or_personal_loan',
  CreditCards = 'credit_cards',
  Bnpl = 'bnpl',
  OtherLoan = 'other_loan',
  OtherCreditFacility = 'other_credit_facility',
}

export const PERSONAL_LIABILITY_OPTIONS: Option<string>[] = [
  {
    label: 'Home Loan',
    value: PersonalLiability.HomeLoan,
  },
  {
    label: 'Investment Property',
    value: PersonalLiability.InvestmentProperty,
  },
  {
    label: 'Car Loan / Personal Loan',
    value: PersonalLiability.AutoOrPersonalLoan,
  },
  {
    label: 'Credit card',
    value: PersonalLiability.CreditCards,
  },
  {
    label: 'Buy Now Pay Later (eg, Afterpay, Zip Pay)',
    value: PersonalLiability.Bnpl,
  },
  {
    label: 'Other Loan (outstanding balance)',
    value: PersonalLiability.OtherLoan,
  },
  {
    label: 'Other Credit Facility (credit limit)',
    value: PersonalLiability.OtherCreditFacility,
  },
];
